// removed by extract-text-webpack-plugin
module.exports = {"actionsPanel":"_1Hkd_PpL_d625ZFOKwDTgP","menuItem":"LYif8brlluwqpaKenBf1N","menuTitle":"_2dO15G7a8QaylkecICh1f9","messagePlaceholder":"-IkssHzD5lcuUjEQRNaUs","contentPanel":"_1L9Km7CaF99tejJ0RDa_xj","isActive":"_2ORu_Ag7eG1eTent6eKsf6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/RootContainer.css
// module id = 1286
// module chunks = 0